import React from 'react';
import Icon from '../../Icon/Icon';
import Spinner from '../../Spinner/Spinner';
import * as S from './DefaultButton.styled';
import { DefaultButtonProps } from './DefaultButton.types';

const Button = React.forwardRef<HTMLButtonElement, DefaultButtonProps>(
  (
    {
      size = 'medium',
      type = 'button',
      colorType = 'main',
      onClick,
      children,
      disabled = false,
      isLoading = false,
      isLeftIcon = false,
      isRightIcon = false,
      leftIconName,
      rightIconName,
      ...props
    },
    forwardedRef,
  ) => {
    const iconSize = size === 'small' ? 20 : 24;
    const spinnerSize = size === 'small' ? 'xSmall' : 'small';

    return (
      <S.Button
        type={type}
        ref={forwardedRef}
        size={size}
        colorType={colorType}
        onClick={onClick}
        disabled={disabled}
        isLeftIcon={isLeftIcon}
        isRightIcon={isRightIcon}
        isLoading={isLoading}
        {...props}
      >
        {isLeftIcon ? <Icon iconName={leftIconName} size={iconSize} /> : null}
        {isLoading ? <Spinner className='sp' size={spinnerSize} /> : null}
        {children}
        {isRightIcon ? <Icon iconName={rightIconName} size={iconSize} /> : null}
      </S.Button>
    );
  },
);

export default Button;
